import {
  FaArrowLeft,
  FaArrowRight,
  FaChevronLeft,
  FaChevronRight,
  FaSearchPlus,
} from 'react-icons/fa';
import { IoLogoAndroid, IoMdClose, IoMdEye, IoMdEyeOff } from 'react-icons/io';
import { FaChevronDown } from 'react-icons/fa';
import { FaChevronUp } from 'react-icons/fa';
import { FaBars } from 'react-icons/fa';
import { FaRegPlusSquare } from 'react-icons/fa';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { FaTv } from 'react-icons/fa';
import { RxCross2 } from 'react-icons/rx';
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import { BiLoaderCircle } from 'react-icons/bi';
import { FaHandPointDown } from 'react-icons/fa';
import { FaSignInAlt } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';
import { VscTriangleDown } from 'react-icons/vsc';
import { FiCalendar } from 'react-icons/fi';
import { MdOutlineCalendarMonth } from 'react-icons/md';
import { IoChevronBackSharp, IoChevronForwardSharp, IoWalletOutline } from 'react-icons/io5';
import { RiBankFill } from 'react-icons/ri';
export const Icons = {
  Android: IoLogoAndroid,
  SearchPlus: FaSearchPlus,
  Down: FaChevronDown,
  Up: FaChevronUp,
  Menu: FaBars,
  PlusSquare: FaRegPlusSquare,
  MinusSquare: AiOutlineMinusSquare,
  Close: IoIosCloseCircleOutline,
  Tv: FaTv,
  Cross: RxCross2,
  Eye: FaEye,
  EyeSlash: FaEyeSlash,
  Home: FaHome,
  Loading: BiLoaderCircle,
  PointDown: FaHandPointDown,
  SignIn: FaSignInAlt,
  Lock: FaLock,
  TriangleDown: VscTriangleDown,
  Calendar: FiCalendar,
  Back: FaChevronLeft,
  Forward: FaChevronRight,
  calendar: MdOutlineCalendarMonth,
  chevronBack: IoChevronBackSharp,
  chevronForward: IoChevronForwardSharp,
  openEye: IoMdEye,
  closeEye: IoMdEyeOff,
  previous: FaArrowLeft,
  next: FaArrowRight,
  close: IoMdClose,
  wallet: IoWalletOutline,
  bank: RiBankFill,
};
